import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import {
  ReceptionInfoResource,
  WebReserveResource,
  TicketSettingResource,
  CustomerIntroducerRequestResource,
} from '@blcloud/bl-ng-resource';
import { IWebReserve, ITicketSetting, ICustomerInfo } from '@blcloud/bl-datamodel';
import { IReceptionInfo } from '@blcloud/bl-datamodel/entity/deals';
import { BlConditionType, BlListResponseBody } from '@blcloud/bl-ng-common';
import { LogicalDeleteDiv } from '@blcloud/bl-datamodel/enum/common/logical-delete-div';
import { of as ObservableOf } from 'rxjs/observable/of';
import {
  isNil as _isNil,
} from 'lodash';
import {
  LoginResourceService,
} from '@blcloud/bl-ng-share-module';
import { ContractConst } from '@blcloud/bl-datamodel/const/contract';

/**
 * Web予約詳細サービス
 */
@Injectable()
export class WebReserveDetailService {

  constructor(
    private receptionInfoResource: ReceptionInfoResource,
    private webReserveResource: WebReserveResource,
    private ticketSettingResource: TicketSettingResource,
    private customerIntroducerRequestResource: CustomerIntroducerRequestResource,
    private loginResourceService: LoginResourceService,
  ) { }

  /**
   * Web予約情報を検索する
   * @param blTenantId BLテナントID
   * @param webReserveNum Web予約番号
   * @return Web予約情報
   */
  getWebReserve(blTenantId: string, webReserveNum: string): Observable<IWebReserve> {
    // 検索条件の初期化
    const webReserve: IWebReserve = {};

    // BLテナントID
    webReserve.webReserveBlTenantId = blTenantId;

    // Web予約番号
    webReserve.webReserveNum = webReserveNum;

    // Web予約情報の検索を実行
    return this.webReserveResource.getById(this.webReserveResource.getIdString(webReserve), { subject: 'common'});
  }

  /**
   * 受付情報を取得する
   * @param receptionInfo 受付情報
   */
  getReception(receptionInfo: IReceptionInfo) {
    return this.receptionInfoResource.getById<IReceptionInfo>(this.receptionInfoResource.getIdString(receptionInfo));
  }

  /**
   * チケット設定を取得する
   * @param organizationCode 組織コード
   * @param ticketCodeList 検索対象チケットコードリスト
   */
  getTicketSettingList(ticketCodeList: string[]): Observable<ITicketSetting[]> {
    if (ticketCodeList.length === 0) {
      return ObservableOf([]);
    }
    const conditions = [
      { key: 'logicalDeleteDiv', value: LogicalDeleteDiv.Valid, type: BlConditionType.Equal },
      { key: 'ticketCode', value: ticketCodeList, type: BlConditionType.In },
    ];
    const sortFields = [
      { field: 'ticketCode', desc: false },
    ];
    return this.ticketSettingResource.getAll({
      conditions: conditions,
      fields: ['ticketCode', 'ticketName'],
      sortFields: sortFields
    }).pipe(
      map(response => response && response.searchResultList)
    );
  }

  /**
   * 紹介者コードから顧客情報を取得する
   * @param introducerCode 紹介者コード
   */
  getCustomerintroducerrequest(introducerCode: string): Observable<ICustomerInfo> {
    if (_isNil(introducerCode) ) {
      return ObservableOf(null);
    }
    const body = {
      introducerCode: introducerCode,
    };
    return this.customerIntroducerRequestResource.post<BlListResponseBody<ICustomerInfo>>(body).pipe(
      map(response => {
          if (response) {
            return response;
          }
          return null;
        }
      ),
      catchError(() => {
        return ObservableOf(null);
      })
    );
  }

  /**
   * クーポン管理サービスOP有効判定
   */
  getCouponMangeService() {
    return this.loginResourceService.isAvailableService(ContractConst.SERVICEID_OPT_CMN_COUPON_MANAGE);
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/web-reserve-detail/web-reserve-detail.service.ts